"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-5 w-24 bg-muted animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        <li data-index={0}>
          <Link to="/PublicServicesPage" className="text-muted-foreground hover:text-secondary transition-colors">Public Records</Link>
        </li>
        <li data-index={1}>
          <Link to="#" className="text-muted-foreground hover:text-secondary transition-colors">Filing Reports</Link>
        </li>
        <li data-index={2}>
          <Link to="/TransparencyPage" className="text-muted-foreground hover:text-secondary transition-colors">Transparency Portal</Link>
        </li>
        <li data-index={3}>
          <Link to="/ContactPage" className="text-muted-foreground hover:text-secondary transition-colors">Contact Us</Link>
        </li>
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-secondary transition-colors">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  return <section data-section-id="264840" id="footer" className="bg-background text-foreground pt-16 pb-8 border-t border-border">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8 mb-12">
          
          {}
          <div className="flex flex-col items-start">
            <Link to="/" className="mb-6 inline-block">
              <WvcLogo className="h-10 w-auto" />
            </Link>
            <p className="text-muted-foreground leading-relaxed mb-6 font-default">
              Metropolitan Central Police Department is committed to professional excellence, public safety, and transparent community engagement across the metropolitan area.
            </p>
          </div>

          {}
          <div>
            <h3 className="font-default text-lg font-bold mb-6 text-primary uppercase tracking-wider">Resources</h3>
            <MenuProvider menu_id="38">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default text-lg font-bold mb-6 text-primary uppercase tracking-wider">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-secondary shrink-0 mt-0.5" />
                <Link to="tel:555-0123" className="text-muted-foreground hover:text-secondary transition-colors font-default">
                  Non-Emergency: 555-0123
                </Link>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-secondary shrink-0 mt-0.5" />
                <Link to="mailto:info@metropolice.gov" className="text-muted-foreground hover:text-secondary transition-colors break-all font-default">
                  info@metropolice.gov
                </Link>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-secondary shrink-0 mt-0.5" />
                <span className="text-muted-foreground font-default">
                  400 Justice Plaza<br />
                  Metropolitan City, MC 10101
                </span>
              </li>
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default text-lg font-bold mb-6 text-primary uppercase tracking-wider">Precinct Hours</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Clock className="w-5 h-5 text-secondary shrink-0 mt-0.5" />
                <div className="text-muted-foreground flex flex-col gap-1 font-default">
                  <span className="flex justify-between gap-4">
                    <span>Admin:</span>
                    <span className="text-foreground font-semibold">8:00 AM - 5:00 PM</span>
                  </span>
                  <span className="flex justify-between gap-4">
                    <span>Records:</span>
                    <span className="text-foreground font-semibold">9:00 AM - 4:00 PM</span>
                  </span>
                  <span className="flex justify-between gap-4">
                    <span>Patrol:</span>
                    <span className="text-foreground font-semibold">24 / 7 / 365</span>
                  </span>
                </div>
              </li>
            </ul>
          </div>

        </div>

        {}
        <div className="pt-8 border-t border-border/50 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted-foreground text-center md:text-left font-default">
            &copy; {new Date().getFullYear()} Metropolitan Central Police Department. All rights reserved.
          </p>
          <div className="flex gap-4 text-sm text-muted-foreground font-default">
            <Link to="#" className="hover:text-secondary transition-colors">Privacy Policy</Link>
            <Link to="#" className="hover:text-secondary transition-colors">Public Disclosure</Link>
          </div>
        </div>
      </div>
    </section>;
}